"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var tiktokTheme = {
  tenant: {
    primary: "#000000"
  }
};
var _default = exports["default"] = tiktokTheme;